<!--急救车 展示-->
<template>
  <div
    v-if="showContent"
    id="printPatientInfo"
  >
    <basicInfo id="basicInfo"/>
    <!--    <basic-info-group id="basicInfo"/>-->
    <!--    <connect-patient/>-->
    <ambulance-status id="ambulance-status"/>
    <situation id="situation"/>
    <drug id="drug"/>
    <check id="check"/>
    <hospital-emergency/>
    <!--    <div class="button-container container">-->
    <!--      <el-button @click="showPrint = true">打印</el-button>-->
    <!--    </div>-->
    <my-dialog-form
      :width="420"
      :dialog-form-visible="showPrint"
      confirm-bottom-text="打印"
      title="请选择需要打印的内容"
      @confirmOk="isPrint"
    >
      <template #body>
        <div class="situation-print container">
          <el-checkbox-group v-model="checkList">
            <el-row>
              <el-col :span="7" :offset="0">
                <el-checkbox label="急救事例"/>
              </el-col>
              <el-col :span="6" :offset="9">
                <el-checkbox label="就诊史"/>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="checkList">
            <el-row>
              <el-col :span="7" :offset="0">
                <el-checkbox label="急救车出车情况"/>
              </el-col>
              <el-col :span="6" :offset="9">
                <el-checkbox label="急救状况"/>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="checkList">
            <el-row>
              <el-col :span="7" :offset="0">
                <el-checkbox label="急救措施"/>
              </el-col>
              <el-col :span="6" :offset="9">
                <el-checkbox label="检验"/>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
      </template>
    </my-dialog-form>
  </div>
</template>

<script>
import BasicInfo from "@components/patients/BasicInfo.vue";
import AmbulanceStatus from "@/components/patients/AmbulanceStatus.vue";
import Situation from "@components/patients/Situation.vue";
import Drug from "@components/patients/Drug.vue";
import Check from "@components/patients/Check.vue";
import MyDialogForm from "@components/customDialog/MyDialogForm.vue";
import HospitalEmergency from "@components/patients/HospitalEmergency";
import { getPdf } from "@/utils/htmlToPdf.js";
import { getPatient } from "@/api/hospitalList";
import { showWindowMessage } from "@utils/notification";
import "@/assets/css/patients.scss";

export default {
  name: "ShowPatient",
  components: {
    HospitalEmergency,
    BasicInfo,
    AmbulanceStatus,
    Situation,
    Drug,
    Check,
    MyDialogForm,
  },
  provide() {
    return {
      patientBasicInfo: this.printTable
    };
  },
  data() {
    return {
      showContent: false,
      patientID: "",
      patientBasicInfo: {},
      isShowPatient: false, // 是否属于查看
      showPrint: false,
      checkList: [
        "急救车出车情况",
        "就诊史",
        "急救状况",
        "检验",
        "急救措施",
        // "入院急救",
        "急救事例"
      ], // 默认全选
      // 打印 名称 与 ID 对应表
      printTable: {
        "急救车出车情况": "ambulance-status",
        "就诊史": "",
        "急救状况": "situation",
        "检验": "check",
        "急救措施": "drug",
        // "入院急救": "operation",
        "急救事例": "basicInfo"
      },
      printList: [
        "急救车出车情况",
        "就诊史",
        "急救状况",
        "检验",
        "急救措施",
        "入院急救",
        // "急救事例"
      ]
    };
  },
  mounted() {
    this.patientID = this.$route.params.id;
    this.getPatientInfo();
    const all = this.$route.path.split("/");
    this.isShowPatient = all[1] === "showPatient";
  },
  methods: {
    async getPatientInfo() {
      try {
        const patient = await getPatient(this.patientID);
        patient.pageInfo = {
          isWriteMore: this.isWriteMore,
          isAddPatient: this.isAddPatient,
          isShowPatient: this.isShowPatient,
        };
        this.$store.commit("updateShowOrEditPatientInfo", patient);
        this.showContent = true;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    // printClick() {
    //   this.showPrint = true;
    // },
    // returnPatientBasicInfo() {
    //   return this.patientBasicInfo;
    // },
    printElement() {
      let templist = [];
      templist = this.printList.map((e) => {
        const b = this.checkList.includes(e);
        if (b) {
          return 0;
        } else {
          return e;
        }
      });
      let removeID = [];
      removeID = templist.map((e) => {
        if (e) {
          return this.printTable[e];
        }
      });
      removeID.forEach((e) => {
        try {
          const element = document.getElementById(e);
          element.style.display = "none";
        } catch (e) {
          console.log(e);
        }
      });
    },
    showElement() {
      // 展示因为打印而隐藏的element
      const showList = [];
      for (const key in this.printTable) {
        showList.push(this.printTable[key]);
      }
      showList.forEach((e) => {
        try {
          const element = document.getElementById(e);
          element.style.display = "block";
        } catch {
        }
      });
    },
    isPrint(e) {
      if (e === "confirm") {
        this.printElement();
        const element = document.getElementById("printPatientInfo");
        element.style.paddingTop = "200px";
        getPdf("printPatientInfo", this.patientBasicInfo.name + "基本信息");
        this.showElement();
      }
      this.showPrint = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .situation-print {
    .el-row {
      height: 46px;
      line-height: 46px;
    }
  }

  .dialog-footer {
    .el-button {
      border-radius: 10px;
    }
  }
}
</style>
